import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Form from "react-bootstrap/Form";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../Helpers/config";
import { errorMessages } from "../../Helpers/ErrorMessages";
import { titleCase, removeTime } from "../../Utils/titleCaseFunction";
import { formatAmount, formatDigits } from "../../Utils/formatAmount";
import { history } from "../../Helpers/history";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPaper,
  CustomPagination,
} from "../../Utils/Tables/CustomTable";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import {
  useExcelReports,
  usePdfReports,
} from "../Invoice/CustomHooks/useExcelReports";
import { dateStringConvertT } from "../../Utils/ConvertDate";

const headData = [
  { id: "sl", numeric: false, disablePadding: false, label: "Sl" },
  { id: "medicineName", numeric: false, disablePadding: false, label: "Product Name" },
  { id: "strength", numeric: false, disablePadding: false, label: "Strength" },
  { id: "batch_number", numeric: false, disablePadding: false, label: "Batch Number" },
  { id: "expiry_date", numeric: false, disablePadding: false, label: "Expiry Date" },
  { id: "in_quantity", numeric: false, disablePadding: false, label: "In Quantity" },
  { id: "out_quantity", numeric: false, disablePadding: false, label: "Sold Quantity" },
  { id: "stock", numeric: false, disablePadding: false, label: "Stock" },
  { id: "cost_price", numeric: false, disablePadding: false, label: "Cost Price" },
  { id: "stock_price", numeric: false, disablePadding: false, label: "Stock Value" },
];

const StockBatchWise = ({ actions, snackbars }) => {
  const [stockBatch, setStockBatch] = useState({
    data: [],
    stockCount: 0,
    loading: "idle",
    total_stock_value: 0,
    total_stock: 0,
  });

  const [activePage, setActivePage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");

  const fetchData = () => {
    setStockBatch((prev) => ({ ...prev, loading: "loading" }));

    axios
      .post(`${config.epharmUrl}/Creport/active_batch`, {
        search: searchValue,
        page: activePage,
        per_page: perPage,
      })
      .then((res) => {
        const data = res.data ?? {};
        setStockBatch({
          data: data.data ?? [],
          stockCount: data.total_count ?? 0,
          total_stock_value: data.total_value ?? 0,
          total_stock: data.total_stock ?? 0,
          loading: "success",
        });
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        setStockBatch((prev) => ({ ...prev, loading: "error" }));
      });
  };

  useEffect(() => {
    fetchData();
  }, [activePage, searchValue, perPage]);

  const handleChangeSearch = (e) => {
    setSearchValue(e.target.value);
    setActivePage(1);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setActivePage(1);
  };

  const { exportExcel } = useExcelReports(actions, {
    file_name: "Stock Batchwise",
    url: "Creport/stock_batch_wise_report_excel",
  });

  const { exportPDF } = usePdfReports(actions, {
    file_name: "Stock Batchwise",
    url: "Creport/stock_batch_wise_report_pdf",
  });

  const { data, stockCount, total_stock_value, total_stock, loading } = stockBatch;
  const { open, message, variant } = snackbars;

  const components = [
    { label: "Stock Report", path: "/stockreport" },
    { label: "Stock Report (Batch Wise)", path: "/stockbatchwise" },
  ];

  const isLoading = loading === "loading";
  const isError = loading === "error";
  const isSuccess = loading === "success";

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Stock Report (Batch Wise)"
        heading="Stock"
        subHeading="Stock Report (Batch Wise)"
        link={history.location.pathname}
      />
      <ReusableRouteTabs value={history.location.pathname} tabHeading={components} />
      <PharmacySnackbar open={open} message={message} variant={variant} handleCloseBar={() => actions.snackbarActions.hideSnackBar()} />
          {/* Totals Display */}
          <div className="d-flex justify-content-between border-top pt-2">
            <div><strong>Total Stock:</strong> {formatDigits(total_stock)}</div>
            <div><strong>Total Stock Value:</strong> {formatAmount(total_stock_value.toFixed(2))}</div>
          </div>
      <MuiPaper>
        <EnhancedTableToolbar title="Stock Batchwise Report">
          <div className="d-flex justify-content-between align-items-center w-100 mb-2">
            <div className="d-flex gap-2">
              <button onClick={exportExcel} className="btn btn-sm pharmacy-btn mr-1">
                Download Excel
              </button>
              <button onClick={exportPDF} className="btn btn-sm pharmacy-btn mr-1">
                Download PDF
              </button>
            </div>
            <Form.Control
              type="text"
              value={titleCase(searchValue)}
              onChange={handleChangeSearch}
              className="form__control"
              placeholder="Search by name, batch or reference"
              style={{ maxWidth: "300px" }}
            />
          </div>


        </EnhancedTableToolbar>

        {/* Scrollable Table */}
        <TableContainer component={Paper} style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Table stickyHeader aria-label="stock batchwise table">
            <EnhancedTableHead headCells={headData} />
            <TableBody>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    <img src="/images/listPreloader.gif" alt="Loading..." style={{ width: "5%" }} />
                  </TableCell>
                </TableRow>
              )}

              {isSuccess && data.length > 0 ? (
                data.map((d, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{(activePage - 1) * perPage + index + 1}</TableCell>
                    <TableCell>
                      <Link to={`/medicinedetails/${d.product_id}`} style={{ color: "#09905c" }}>
                        {titleCase(d.product_name)}
                      </Link>
                    </TableCell>
                    <TableCell>{d.strength}</TableCell>
                    <TableCell>{d.batch_number}</TableCell>
                    <TableCell>{d.expiry_date ? dateStringConvertT(d.expiry_date) : ""}</TableCell>
                    <TableCell>{formatDigits(d.in_quantity)}</TableCell>
                    <TableCell>{formatDigits(d.out_quantity)}</TableCell>
                    <TableCell>{formatDigits(d.stock)}</TableCell>
                    <TableCell>{formatDigits(d.cost_price)}</TableCell>
                    <TableCell>{formatDigits(d.stock_price)}</TableCell>
                  </TableRow>
                ))
              ) : (
                !isLoading &&
                !isError && (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      No records found
                    </TableCell>
                  </TableRow>
                )
              )}

              {isError && (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    Server did not return a valid response.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center p-3">
          <div className="d-flex align-items-center">
            <span className="mr-2"><strong>Rows per page:</strong></span>
            <Form.Control
              as="select"
              value={perPage}
              onChange={handlePerPageChange}
              style={{ width: "80px" }}
            >
              {[10, 20, 50, 100].map((num) => (
                <option key={num} value={num}>{num}</option>
              ))}
            </Form.Control>
          </div>

          <CustomPagination
            data={data}
            records={perPage}
            activePage={activePage}
            total_count={stockCount}
            handleChangeNextPage={handlePageChange}
          />
        </div>
      </MuiPaper>
    </div>
  );
};

function mapStateToProps(state) {
  return { snackbars: state.snackbars };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StockBatchWise);
